export default __webpack_public_path__ + "static/media/logo.df531463.jpeg";